import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import ContactForm from './components/ContactForm';
import ContactInfo from './components/ContactInfo';

const Contact = () => {
  useEffect(() => {
    const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';

    const contactPageSchema = {
      '@context': 'https://schema.org',
      '@type': 'ContactPage',
      name: 'SG SMART GEO 문의하기 | 지반조사·계측·안전진단 견적 및 상담',
      url: `${siteUrl}/contact`,
      description:
        '지반조사, 계측, 정밀안전진단, AI 분석 관련 견적 및 상담 문의를 도와드립니다. SG SMART GEO에 문의하세요.',
      inLanguage: 'ko',
      dateModified: '2026-04-12',
      isPartOf: {
        '@type': 'WebSite',
        name: 'SG SMART GEO',
        url: siteUrl,
      },
      about: {
        '@type': 'Organization',
        name: '주식회사 에스지 SG SMART GEO',
        url: siteUrl,
        contactPoint: {
          '@type': 'ContactPoint',
          contactType: 'customer service',
          availableLanguage: '한국어',
          url: `${siteUrl}/contact`,
        },
      },
      breadcrumb: {
        '@type': 'BreadcrumbList',
        itemListElement: [
          {
            '@type': 'ListItem',
            position: 1,
            name: '홈',
            item: siteUrl,
          },
          {
            '@type': 'ListItem',
            position: 2,
            name: '문의하기',
            item: `${siteUrl}/contact`,
          },
        ],
      },
    };

    const organizationSchema = {
      '@context': 'https://schema.org',
      '@type': 'Organization',
      name: '주식회사 에스지 SG SMART GEO',
      url: siteUrl,
      logo: 'https://static.readdy.ai/image/00aed269fb1e179199d0d5bf56fc46fa/e4c97585502309238de2821b4122566a.png',
      address: {
        '@type': 'PostalAddress',
        streetAddress: '천년숲동로 46',
        addressLocality: '안동시',
        addressRegion: '경상북도',
        postalCode: '36728',
        addressCountry: 'KR',
      },
      geo: {
        '@type': 'GeoCoordinates',
        latitude: 36.5684,
        longitude: 128.7294,
      },
      contactPoint: {
        '@type': 'ContactPoint',
        contactType: 'customer service',
        availableLanguage: '한국어',
        url: `${siteUrl}/contact`,
      },
    };

    const scriptId = 'schema-contact';
    let script = document.getElementById(scriptId) as HTMLScriptElement | null;
    if (!script) {
      script = document.createElement('script');
      script.id = scriptId;
      script.type = 'application/ld+json';
      document.head.appendChild(script);
    }
    script.textContent = JSON.stringify([contactPageSchema, organizationSchema]);

    document.title = 'SG SMART GEO 문의하기 | 지반조사·계측·안전진단 견적 및 상담';

    return () => {
      const el = document.getElementById(scriptId);
      if (el) el.remove();
    };
  }, []);

  return (
    <div className="min-h-screen bg-white" style={{ fontFamily: "'Noto Sans KR', sans-serif" }}>
      <Navbar />

      {/* Hero */}
      <section className="pt-36 pb-16 bg-[#F7F8F9]">
        <div className="max-w-7xl mx-auto px-8 md:px-16">
          <div className="flex items-center gap-3 mb-5">
            <span className="w-10 h-1 bg-[#E8521A] rounded-full" />
            <span
              className="text-[#E8521A] text-sm font-bold tracking-widest uppercase"
              style={{ fontFamily: "'Inter', sans-serif" }}
            >
              Contact Us
            </span>
          </div>
          <h1
            className="text-5xl md:text-6xl font-black text-[#1B2A4A] mb-4"
            style={{ fontFamily: "'Noto Sans KR', sans-serif", letterSpacing: '-0.03em' }}
          >
            문의하기
          </h1>
          <p
            className="text-[#1B2A4A]/55 text-lg font-medium"
            style={{ fontFamily: "'Noto Sans KR', sans-serif" }}
          >
            지반조사·계측·안전진단·AI 분석 관련 견적 및 상담을 도와드립니다
          </p>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8 md:px-16">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 items-stretch">
            {/* Left: Form */}
            <ContactForm />

            {/* Right: Info + Map + SNS */}
            <ContactInfo />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Contact;
